import { Component, OnInit } from '@angular/core';
import { GateWayService } from '../../services/gateway-service.service';

@Component({
  selector: 'app-nav-header',
  templateUrl: './nav-header.component.html',
  styleUrls: ['./nav-header.component.css']
})
export class NavHeaderComponent implements OnInit {
  display_name : string;
  username : string;
  constructor(
    private gwService: GateWayService,
  ) {
  }
  ngOnInit() {
    this.display_name = localStorage.getItem('display_name')
    this.username = localStorage.getItem('username')
  }

  async logout() {
    this.gwService.ADMDLogout()
      .subscribe(async () => {
        let state = localStorage.getItem('state')
        localStorage.removeItem('access_token')
        localStorage.removeItem('refresh_token')
        localStorage.removeItem('state')
        this.gwService.getADMDLoginURI(state).subscribe(success => {
          if(success.code == 200) window.location.href = success.data.url
        });
      });
  }
}
